import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { notificationType } from '../../types';
import { hideNotification } from '../../actions/notifications';
import './_styles_/Notification.css';

Notification.propTypes = {
    outerClass: PropTypes.string.isRequired,
    buttonClass: PropTypes.string.isRequired,
    notification: notificationType.isRequired,
};

function Notification(props) {
    const {
        outerClass,
        buttonClass,
        notification,
    } = props;
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const onClose = () => dispatch(hideNotification(notification.id));
    return (
        <div className={`notification ${outerClass}`}>
            <span>{notification.text}</span>
            <button type="button" className={`close-button button-small notification--close ${buttonClass}`} onClick={onClose}>
                <span aria-label={t('misc.dismiss-notification')} role="img"><FontAwesomeIcon icon="times" /></span>
            </button>
        </div>
    );
}

export default Notification;
